import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { $api } from '../../../../helpers/api'
import axios from 'axios'

export const getAboutSection = createAsyncThunk('get about sections data', async () => {
  try {
    const result = await $api.get(`/sections`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const updateAboutSection = createAsyncThunk(
  'update about sections data',
  async ({ sectionId, data }) => {
    try {
      const result = await $api.put(`/sections/${sectionId}`, data)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return console.error(e.message)
      }
    }
  },
)

export const deleteAboutSection = createAsyncThunk(
  'delete about sections data',
  async ({ sectionId }, { rejectWithValue }) => {
    try {
      const result = await $api.delete(`/sections/${sectionId}`)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return rejectWithValue(e.message)
      }
    }
  },
)

const initialState = {
  data: undefined,
  isLoading: false,
  error: null,
}

export const aboutSectionSlice = createSlice({
  name: 'about sections',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAboutSection.pending, state => {
        state.isLoading = true
        state.data = undefined
        state.error = null
      })
      .addCase(getAboutSection.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
        state.error = null
      })
      .addCase(getAboutSection.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
        state.error = action.error.message
      })
  },
})

export const { actions: aboutSectionActions } = aboutSectionSlice
export const { reducer: aboutSectionReducer } = aboutSectionSlice
